import React, { useContext } from 'react'
import runContext from '../Context/RunContext'
function Output() {
  const{outputValue} = useContext(runContext);
  
  return (
    <div className='output'>
      <div className="top-output">
        <p>Output</p>
      </div>
      <div className="midoutput">
        <textarea name="output" readOnly value={outputValue}>
        </textarea>
      </div>
    </div>
  )
}

export default Output
